// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getStorage } from 'firebase/storage';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: 'AIzaSyC4B9P-4H4qe7hnHtdnCiKWhGwAJIVgDR0',
    authDomain: 'homstay-c1fd5.firebaseapp.com',
    projectId: 'homstay-c1fd5',
    storageBucket: 'homstay-c1fd5.appspot.com',
    messagingSenderId: '34825647704',
    appId: '1:34825647704:web:dc79475219b9bb43037c2d',
    measurementId: 'G-YRY3GFPLQY'
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const storage = getStorage(app);
